module.exports = __webpack_public_path__ + "static/media/jGBP.49c78c9f.png";